/**
 * Valida se um CNPJ (tradicional ou alfanumérico) é válido matematicamente.
 * Compatível com Node 12+ (CommonJS) e React (ES Modules).
 * 
 * @param {string} cnpj - String do CNPJ com ou sem máscara.
 * @returns {boolean} - Retorna true se o CNPJ for válido.
 */
function isValidAlphaCnpj(cnpj) {
  if (!cnpj || typeof cnpj !== 'string') {
    return false;
  }

  // Remove caracteres especiais (mantém letras e números)
  const cleaned = cnpj.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

  if (cleaned.length !== 14) {
    return false;
  }

  if (!/^[A-Z0-9]{12}\d{2}$/.test(cleaned)) {
    return false;
  }

  if (/^([A-Z0-9])\1{13}$/.test(cleaned)) {
    return false;
  }

  if (!/^\d{2}$/.test(cleaned.slice(-2))) {
    return false;
  }
  
  // Verifica se tem 14 caracteres (12 base + 2 DV)
  if (cleaned.length !== 14) {
    return false;
  }

  // Função para obter o valor para cálculo do DV conforme tabela do SERPRO
  function getValorDV(char) {
    const code = char.charCodeAt(0);
    // Números (0-9): ASCII 48-57 -> valor 0-9
    if (code >= 48 && code <= 90) {//code <= 57) {
      return code - 48;
    }
  }

  // Converte cada caractere para seu valor de cálculo
  const values = [];
  for (let i = 0; i < 14; i++) {
    values.push(getValorDV(cleaned[i]));
  }

  // --- CÁLCULO DO PRIMEIRO DÍGITO VERIFICADOR (DV1) ---
  // Pesos: 5,4,3,2,9,8,7,6,5,4,3,2 (da direita pra esquerda)
  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let sum1 = 0;
  for (let i = 0; i < 12; i++) {
    sum1 += values[i] * weights1[i];
  }
  
  const rest1 = sum1 % 11;
  const expectedDV1 = (rest1 === 0 || rest1 === 1) ? 0 : 11 - rest1;

  // Verifica se o 13º caractere (índice 12) é o DV1 esperado
  if (values[12] !== expectedDV1) {
    return false;
  }

  // --- CÁLCULO DO SEGUNDO DÍGITO VERIFICADOR (DV2) ---
  // Pesos: 6,5,4,3,2,9,8,7,6,5,4,3,2 (inclui o DV1)
  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let sum2 = 0;
  for (let i = 0; i < 13; i++) {
    sum2 += values[i] * weights2[i];
  }
  
  const rest2 = sum2 % 11;
  const expectedDV2 = (rest2 === 0 || rest2 === 1) ? 0 : 11 - rest2;

  // Verifica se o 14º caractere (índice 13) é o DV2 esperado
  if (values[13] !== expectedDV2) {
    return false;
  }

  return true;
}

export { isValidAlphaCnpj };